export default "<p>\n  patient-search works!\n</p>\n"